import React, { useEffect } from 'react';

import { isEmpty } from 'lodash';

import { bool } from 'prop-types';

import { useParams } from 'react-router-dom';

import useRedirect from 'hooks/useRedirect';
import useUserRedux from 'hooks/useUserRedux';
import { CANDIDATE_SOURCED_DETAILS } from 'routes/constants';

/**
 * Contains all redirect logic strictly for counselor users
 */
const RedirectHelper = ({ isDashboardRedirect, isBYOPRedirect }) => {
  const {
    data: { grades, hasElementaryGrades, hasMiddleHighSchoolGrades },
  } = useUserRedux();
  const { redirect } = useRedirect();
  const { placementHashId, programId } = useParams();

  useEffect(() => {
    if (isDashboardRedirect) {
      const hasAllK12Grades = hasElementaryGrades && hasMiddleHighSchoolGrades;
      if (hasAllK12Grades) {
        // No need for route protection if we have all grades
        return;
      }
      // If only elementary grades are present, we need to enforce this redirect
      // logic and vice versa
      const isElementaryCounselor = hasElementaryGrades && !isEmpty(grades);
      const to = isElementaryCounselor ? '/el/dashboard' : '/dashboard';
      const reason = isElementaryCounselor
        ? 'elementary school counselor'
        : 'not an elementary school counselor';
      redirect({
        to,
        component: 'routes/CounselorRoutes/CounselorRedirects',
        reason,
      });
    }
    if (isBYOPRedirect) {
      redirect({
        to: CANDIDATE_SOURCED_DETAILS({
          placementHashId,
          programId,
        }),
        component: 'routes/CounselorRoutes/RedirectHelper',
        reason: 'Redirecting counselor to candidate sourced byop form',
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [grades, isDashboardRedirect, isBYOPRedirect, hasElementaryGrades]);

  return <></>;
};

RedirectHelper.propTypes = {
  isDashboardRedirect: bool,
  isBYOPRedirect: bool,
};

RedirectHelper.defaultProps = {
  isDashboardRedirect: false,
  isBYOPRedirect: false,
};

export default RedirectHelper;
